<template>
<div id="login">
    <div class="lgWrapper">
            <div class="lgLeft">
                <img src="/static/logo_login.png"/>
            </div>
            <div class="lgRight">
                <div class="lgContent">
                    <h1 class="lgTitle">Đăng nhập</h1>
                    <span v-if="wrong_user_pass" class="message-error text-red">{{error_message}}</span>
                    <span v-if="null_user_pass" class="message-error text-red">{{null_message}}</span>
                    <ul class="lgForm">
                        <li class="username">
                            <input type="text" name="phone" v-model="model.username" class="form-control" required placeholder="Tên đăng nhập" />
                        </li>
                        <li class="password">
                            <input type="password" name="password" v-model="model.password" class="form-control" required placeholder="Mật khẩu" v-on:keyup.13="login()"  />
                        </li>
                        <li>
                            <button type="button" v-on:click="login()" class="btn btn-login">Đăng nhập</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapState
} from "vuex";

export default {
    computed: {
        ...mapState({
            token: state => state.authentication.token,
            resData: state => state.authentication.resData,
        }),
    },
    data: () => ({
        loading: false,
        model: {
            username: '',
            password: ''
        },
        snackbar: false,
        message: '',
        error_message: "Tài khoản hoặc mật khẩu không đúng.",
        null_message: "Tài khoản và mật khẩu không được để trống.",
        wrong_user_pass: false,
        null_user_pass: false,
    }),
    watch: {
        resData() {
            if (this.resData && this.resData.status_code == 400) {
                this.wrong_user_pass = true;
                this.message = 'Tài khoản hoặc mật khẩu không đúng.'
            } else if (this.token && this.token !== '') {
                window.getApp.$emit('APP_LOGIN_SUCCESS');
            }
            this.loading = false;
        }
    },
    methods: {
        login() {
            this.loading = true;
            this.wrong_user_pass = false;
            this.null_user_pass = this.model.username === '' || this.model.password === '';
            if (!this.null_user_pass) {
                this.$store.dispatch('authentication/login', this.model);
            }
        }
    }

};
</script>

<style lang="css" scoped>
#login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
}
</style>
